import { LarosateResult, UrvalsgruppResult, AstaQuery, SearchResult } from '../../types/AstaTypes';

const baseUrl = '/api/antagningsstatistik';

const getQueryParameters = (query: AstaQuery, resultlimit: number = 0, forDocument: boolean = false): string => {
  let queryParameter =
    '?searchfor=' +
    query.searchfor +
    '&searchterm=' +
    query.searchterm +
    '&searchkategori=' +
    query.searchkategori +
    (resultlimit != 0 ? '&pagesize=' + resultlimit : '') +
    '&tillfalle=' +
    query.tillfalle;

  if (!forDocument) {
    queryParameter += '&page=' + query.page;
  }

  const hasLarosaten = query.larosaten != null && query.larosaten.length > 0;
  if (hasLarosaten) {
    queryParameter = queryParameter.concat('&larosaten=' + query.larosaten.join(','));
  }

  const hasValidUtbildningstyp = query.utbildningstyp === 'program' || query.utbildningstyp === 'kurs';
  if (hasValidUtbildningstyp) {
    queryParameter = queryParameter.concat('&utbildningstyp=' + query.utbildningstyp);
  }

  const hasValidSort = !!query.sorteringskolumn && query.sorteringskolumn.length > 0;
  if (hasValidSort) {
    queryParameter = queryParameter.concat('&sorteringskolumn=' + query.sorteringskolumn);
  }

  const isPoangUrval = query.vy === 'antagningspoang-urv1' || query.vy === 'antagningspoang-urv2';
  const hasSorteringsurvalGrupp = query.sorteringsurvalsgrupp !== null && query.sorteringsurvalsgrupp !== '';
  if (isPoangUrval && hasSorteringsurvalGrupp) {
    queryParameter = queryParameter.concat('&sorteringsurvalsgrupp=' + query.sorteringsurvalsgrupp);
  }

  if (query.sorteringsordningdesc === true) {
    queryParameter = queryParameter.concat('&sorteringsordningdesc=true');
  }

  return queryParameter;
};

export const suggest = async (searchfor: string, searchterm: string, pagesize?: number) => {
  const response = await fetch(`${baseUrl}/suggest?searchfor=${searchfor}&searchterm=${searchterm}&pagesize=${pagesize}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return await response.json();
};

export const astaV2Search = async (queryData: AstaQuery, resultlimit: number = 10): Promise<SearchResult> => {
  const queryParameters = getQueryParameters(queryData, resultlimit);
  const response = await fetch(`${baseUrl}/searchTotal${queryParameters}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return await response.json();
};

//clearCache
export const clearCache = async (searchterm: string = '') => {
  const response = await fetch(`${baseUrl}/clearCache?searchterm=${searchterm}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return await response.json();
};

//doAstaLarosaten
export const loadLarosaten = async (queryData: AstaQuery): Promise<LarosateResult> => {
  const queryParameters = getQueryParameters(queryData, 0, true);
  const response = await fetch(`${baseUrl}/larosaten${queryParameters}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return await response.json();
};

//doAstaUrvalsgrupper
export const loadUrvalsgrupper = async (queryData: AstaQuery): Promise<UrvalsgruppResult> => {
  const queryParameters = getQueryParameters(queryData, 0, true);
  const response = await fetch(`${baseUrl}/urvalsgrupper${queryParameters}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return await response.json();
};

export const getDownloadUrl = (AstaResultatStatus: AstaQuery, fileType: 'csv' | 'excel', vy: string, url: string) => {
  var domain = url;
  var path = '/api/antagningsstatistik/' + fileType;
  var i = vy.lastIndexOf('-');
  var vy = vy.substring(0, i);
  const parameter = getQueryParameters(AstaResultatStatus, 0, true);
  return domain + path + parameter + '&vy=' + vy;
};
export const downloadFile = (AstaResultatStatus: AstaQuery, fileType: 'csv' | 'excel', vy: string, url: string, callback: Function) => {
  let downloadUrl = getDownloadUrl(AstaResultatStatus, fileType, vy, url);
  fetch(downloadUrl)
    .then(async (response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const contentDisposition = response.headers.get('Content-Disposition');
      let filename = 'file.' + fileType === 'excel' ? 'xlsx' : fileType;
      if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          filename = match[1];
        }
      }
      const blob = await response.blob();
      return { blob, filename };
    })
    .then(({ blob, filename }) => {
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(downloadUrl);
    })
    .catch((err) => console.error('Download failed:', err, url))
    .finally(() => {
      callback();
    });
};
